import { render, staticRenderFns } from "./synchroContentsCard.vue?vue&type=template&id=b934d72c&"
import script from "./synchroContentsCard.vue?vue&type=script&lang=js&"
export * from "./synchroContentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports